import { Button, PageHeader, TOUCH } from "@nymbl/nos2-rules";
import { CalendarPlus } from "lucide-react";
import { YearSwitcher } from "@/components/pto/YearSwitcher";
import { formatDayCount } from "@/lib/pto/days";

interface PtoHeaderProps {
  year: number;
  currentYear: number;
  onYearChange: (year: number) => void;
  /** Approved days in the year; hidden at 0 or while loading. */
  daysOff: number | null;
  onRequest: () => void;
}

/** The PTO page header in the top bar: title, year switcher, days off, Request time off. */
export function PtoHeader({ year, currentYear, onYearChange, daysOff, onRequest }: PtoHeaderProps) {
  return (
    <PageHeader
      title="PTO"
      period={
        <div className="flex items-center gap-3">
          <YearSwitcher year={year} currentYear={currentYear} onChange={onYearChange} />
          {daysOff !== null && daysOff > 0 && (
            <span className="whitespace-nowrap text-sm text-muted-foreground">
              {`${formatDayCount(daysOff)} off`}
            </span>
          )}
        </div>
      }
      actions={
        <Button className={TOUCH} onClick={onRequest}>
          <CalendarPlus aria-hidden="true" />
          Request time off
        </Button>
      }
    />
  );
}
